import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { monitorCriteriaNameSelector } from '../../../state';
import useMonitorMetadata from './useMonitorMetadata';

export type GetCriteriaNameFn = (id?: string) => string;

const useCriteriaNames = () => {
  const { loading, error } = useMonitorMetadata();
  const { t } = useTranslation();

  const criteriaNames = useRecoilValue(monitorCriteriaNameSelector);

  const getCriteriaName: GetCriteriaNameFn = (id?: string) => {
    if (!id) return t('monitors.criteriaNames.unknown');
    return (
      criteriaNames?.[id] ||
      t(`monitors.criteriaNames.${id}`) ||
      t('monitors.criteriaNames.unknown')
    );
  };

  return { criteriaNames, loading, error, getCriteriaName };
};

export default useCriteriaNames;
